import {
	AUTH_FAILED,
	AUTH_INITIALIZED,
	SET_ACCESS_TOKEN,
	SET_AUTHENTICADED,
	SET_REFRESH_TOKEN,
	SET_USER,
	SET_UNFRESH_ACCESS_TOKEN,
	CLEAR_UNFRESH_ACCESS_TOKEN,
	CLEAR_TOKENS,
	CLEAR_ERRORS
} from "@stofloos/actions/auth";
import { getCookie, deleteCookie } from "@stofloos/middlewares/auth";

const initialState = {
	error: false,
	message: null,
	isAuthenticated: false,
	isFetching: false,
	hasFetched: false,
	unfresh_access_token: getCookie("unfresh_access_token"),
	user: JSON.parse(sessionStorage.getItem("user")),
	access_token: sessionStorage.getItem("access_token")
};

const StofwareAuth = (state = initialState, action) => {
	switch (action.type) {
		case CLEAR_ERRORS:
			return {
				...state,
				isFetching: false,
				error: false,
				message: ""
			};
		case AUTH_INITIALIZED:
			return {
				...state,
				isFetching: true,
				error: false,
				message: "Aan het inloggen..."
			};
		case CLEAR_TOKENS:
			deleteCookie("unfresh_access_token");
			return {
				...state,
				access_token: null,
				refresh_token: null,
				unfresh_access_token: null
			};
		case AUTH_FAILED:
			return {
				...state,
				isFetching: false,
				error: true,
				message: action.error.message ? action.error.message : action.error.msg
			};
		case CLEAR_UNFRESH_ACCESS_TOKEN:
			deleteCookie("unfresh_access_token");
			return {
				...state,
				unfresh_access_token: null
			};
		case SET_UNFRESH_ACCESS_TOKEN:
			return {
				...state,
				unfresh_access_token: action.unfresh_access_token,
				isFetching: false,
				message: null,
				error: false
			};
		case SET_USER:
			return {
				...state,
				user: action.user,
				isFetching: false,
				message: null,
				error: false
			};
		case SET_AUTHENTICADED:
			return {
				...state,
				isAuthenticated: action.isAuthenticated,
				isFetching: false,
				message: null,
				error: false
			};
		case SET_ACCESS_TOKEN:
			return {
				...state,
				access_token: action.access_token,
				isFetching: false,
				message: null,
				error: false
			};
		case SET_REFRESH_TOKEN:
			return {
				...state,
				refresh_token: action.refresh_token,
				isFetching: false,
				message: null,
				error: false
			};
		default:
			return state;
	}
};

export default StofwareAuth;
